import React, { Component } from "react";
import {
  Form,
  FormGroup,
  Label,
  Input,
  UncontrolledTooltip,
  Button
} from "reactstrap";
import Filter from '../Filter';
import LessonCard from "../LessonCard";
export default class AddRules extends Component {
  deleteRule = () => {
    console.log("rule deleted!!");
  };
  render() {
    const indexes = [0, 1];
    const rulesBodyRight = (
      <React.Fragment>
         <Filter
                onChg={e => console.log("changed")}
              />
        <Form inline>
          <FormGroup className="mb-2 mr-sm-2 mb-sm-0 rules-item">
            <div className="author-lesson-checkbox">
              <Input type="checkbox" />
              <span class="checkmark" />
            </div>
            <Label
              id={`rule_threshold_item-right-${indexes[0]}`}
              for="rule_threshold"
            >
              Entrance Questions:{" "}
            </Label>
            <Input type="number" name="rule_threshold" id="rule_threshold" />
            questions
            <UncontrolledTooltip
              placement="bottom"
              target={`rule_threshold_item-right-${indexes[0]}`}
              style={{ backgroundColor: "#4C4C4C" }}
            >
              Rules description...
            </UncontrolledTooltip>
          </FormGroup>
          <FormGroup className="mb-2 mr-sm-2 mb-sm-0 rules-item">
            <div className="author-lesson-checkbox">
              <Input type="checkbox" />
              <span class="checkmark" />
            </div>
            <Label
              id={`rule_threshold_item-right-${indexes[1]}`}
              for="rule_threshold"
            >
              Entrance Threshold to Fast Forward:{" "}
            </Label>
            <Input type="number" name="rule_threshold" id="rule_threshold" />%
            <UncontrolledTooltip
              placement="bottom"
              target={`rule_threshold_item-right-${indexes[1]}`}
              style={{ backgroundColor: "#4C4C4C" }}
            >
              Rules description...
            </UncontrolledTooltip>
          </FormGroup>
        </Form>
      </React.Fragment>
    );
    return (
      <div>
        <React.Fragment>
        <LessonCard
            iconClass="rules-yellow"
            heading="Add Rules"
            subHeading="Add Rules to the Apostrophes lesson"
            children={rulesBodyRight}
            footerButtons={[
                <Button className='lesson-cancel-btn' onClick={() => this.props.closeAddRules("addRules")} >Cancel Changes</Button>,
                <Button className='lesson-action-btn'>+ Add Rules</Button>
            ]}
        />
        </React.Fragment>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Users/Authors/AuthorLesson/AddRules.js